import { LocalStorage } from 'quasar'

export function CART_READY (state) {
  state['ready'] = true
}

// export function ITEMS_CART_SET_ITEM_EXTRA (state, { extra, status }) {
//   const extras = state.currentItem.get('extras')

//   let currentIndex = false
//   for (const i in extras) {
//     if ((extras[i].id && extras[i].id === extra.id) || extras[i].objectId === extra.id) {
//       if (!status) {
//         extras.splice(i, 1)
//       } else {
//         currentIndex = i
//       }
//       break
//     }
//   }

//   if (status && currentIndex === false) {
//     extras.push({
//       __type: 'Pointer',
//       className: 'RestaurantItemExtra',
//       objectId: extra.id
//     })
//   }
//   state.currentItem.set('extras', extras)
//   state['enabledExtras'] = extras
// }

export function ITEMS_CART_TOGGLE_ITEM_EXTRA (state, extra) {
  const extras = state.currentItem.get('extras')
  let found = false
  const extraId = (extra.id) ? extra.id : extra.objectId

  for (const i in extras) {
    if ((extras[i].id && extras[i].id === extraId) || extras[i].objectId === extraId) {
      extras.splice(i, 1)
      found = true
    }
  }

  if (!found) {
    extras.push({
      __type: 'Pointer',
      className: 'RestaurantItemExtra',
      objectId: extra.id
    })
  }

  state.currentItem.set('extras', extras)
  state['enabledExtras'] = extras
}

export function CART_RESET (state) {
  state['price'] = 0
  state['itemsCountById'] = {}
  state['items'] = []
  state['ready'] = false
  LocalStorage.remove('cart.items')
}

export async function CART_DELETE_ITEM (state, itemIndex) {
  if (state.items[itemIndex].id) {
    await state.items[itemIndex].destroy()
  }

  state.itemsCountById[state.items[itemIndex].get('restaurant_item').id]--
  state.items.splice(itemIndex, 1)
  LocalStorage.set('cart.items', state.items)
}

export function CART_SET_CURRENT_ITEM (state, item) {
  state['currentItem'] = item
  state['enabledExtras'] = item && item.attributes ? item.get('extras') : []
}

export function CART_LOADING (state, status = true) {
  state['loading'] = status
}

export function CART_SET_ITEMS (state, { items, order }) {
  state['items'] = items

  LocalStorage.set('cart.items', items)
  for (const i in items) {
    if (!items[i].get('restaurant_item_summary') && order && order.id) {
      items[i].set('restaurant_item_summary', order)
    }

    if (items[i].get('restaurant_item') && items[i].get('restaurant_item').id) {
      if (!state.itemsCountById[items[i].get('restaurant_item').id]) {
        state.itemsCountById[items[i].get('restaurant_item').id] = 0
      }
      state.itemsCountById[items[i].get('restaurant_item').id]++
    }
  }
}

export function CART_ADD_ITEMS (state, items) {
  for (const i in items) {
    state.items.push(items[i])
    if (items[i].get('restaurant_item') && !state.itemsCountById[items[i].get('restaurant_item').id]) {
      state.itemsCountById[items[i].get('restaurant_item').id] = 0
    }
    state.itemsCountById[items[i].get('restaurant_item').id]++
  }
  LocalStorage.set('cart.items', state.items)
}

export function CART_UPDATE_CURRENT_ITEM (state, itemIndex) {
  state.loading = true
  state.items[itemIndex] = state.currentItem
  LocalStorage.set('cart.items', state.items)
  setTimeout(() => {
    state.loading = false
  }, 10)
}

export function CART_RESET_EXTRAS (state, extras) {
  state['enabledExtras'] = []
}


export function CART_RESET_CURRENT_ITEM (state) {
  state['currentItem'] = false
}

export function CART_SET_SCHEDULED_AT (state, payload) {
  state['scheduledAt'] = payload
  if(payload == false) {
    LocalStorage.remove('scheduledAt')
    return
  }
  LocalStorage.set('scheduledAt', payload)
}

export function CART_SET_SPECIAL_REQUEST (state, payload) {
  state['special_request'] = payload
  LocalStorage.set('special_request', payload)
}

export function CART_SET_PRICE (state, payload) {
  state['price'] = payload
  LocalStorage.set('cart.price', payload)
}


// export function ADD_MEAL_ORDER (state, meal) {
//   state.mealOrders.push(meal)
// }

// export function RESET_MEAL_ORDERS (state) {
//   state.mealOrders = []
// }